export default __webpack_public_path__ + "static/osquery-e3266685e1c9eaffc5e16e1ed71010b3.png";